const AVATARS = {
  'Stacy Kildal':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/screen%20shot%202015-04-24%20at%2012.38.02%20pm.png',
  'Billie Anne Grigg':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/1385123_561042430635560_1108413716_n.jpg',
  'Heather D Satterley':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/heather.jpg',
  'Ben Rashkovich':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/bdr-wordpress.jpg',
  'Ben Johnson':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/ben_j.jpg',
  'Jennifer Dunn':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/jd%20headshot.jpeg',
  'Rieva Lesonsky':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/rieva%20lesonsky.jpg',
  'Miriam Reimer':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/miriam%20reimer%20-%20headshot.jpg',
  'Rachel Blakely-Gray':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/rachel-patriot-bio.jpg',
  'Robb Todd':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/robb-todd.jpg',
  'Ryan Robinson':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/ryan-robinson-fundera.jpg',
  'Sara Oberst':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/sara_oberst_headshot.jpeg',
  'Sara Sugar':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/sara-sugar.png',
  'Sarita Harbour':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/sarita-harbour.jpg',
  'Seth David':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/seth%20david.jpg',
  'Sujan Patel':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/sujan%20(1).png',
  'Tomer London':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/tomer-london.jpg',
  'Bryce Warnes':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/bryce_bench_bio.jpg',
  'Gretchen Schmid':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/gretchen%20headshot.jpg',
  'Andy Roe':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/andyroe1.jpg',
  'Anisha Sekar':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/anisha sekar_datafox headshot 500x500.jpg',
  'Alfonso Serrano':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/alfonso.jpeg',
  'Reydavid Julio':
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/vsco-photo-1.jpg',
  TSheets:
    'https://www.fundera.com/blog/wp-content/uploads/gravatar/tsheetsavatar.jpeg',
};

const GENERAL_AUTHOR = {
  id: 'dXNlcjoxNw==',
  name: 'Meredith Wood',
  fdsAuthorBio: {
    company: 'Fundera',
    companyUrl: 'https://www.fundera.com',
    jobTitle: 'Vice President and Founding Editor',
    avatar: {
      sourceUrl:
        'https://secure.gravatar.com/avatar/1d46d37bcf4c56922f7f3b2b6b6d86b1?s=96&d=mm&r=g',
    },
    biography: [
      {
        content:
          'Meredith Wood is the founding editor of the Fundera Ledger and a vice president at Fundera. She launched the Fundera Ledger in 2014 and has specialized in financial advice for small business owners for almost a decade. Meredith is frequently sought out for her expertise in small business lending. She is a monthly columnist for AllBusiness, and her advice has appeared in the SBA, SCORE, Yahoo, Amex OPEN Forum, Fox Business, American Banker, Small Business Trends, MyCorporation, Small Biz Daily, StartupNation, and more. Email: <a href="mailto:meredith@fundera.com">meredith@fundera.com</a>.',
      },
    ],
  },
  authorBio: {
    company: 'Fundera',
    companyUrl: 'https://www.fundera.com',
    gravatar: 'mere.jpeg',
    jobTitle: 'Vice President and Founding Editor',
    description:
      'Meredith Wood is the founding editor of the Fundera Ledger and a vice president at Fundera. She launched the Fundera Ledger in 2014 and has specialized in financial advice for small business owners for almost a decade. Meredith is frequently sought out for her expertise in small business lending. She is a monthly columnist for AllBusiness, and her advice has appeared in the SBA, SCORE, Yahoo, Amex OPEN Forum, Fox Business, American Banker, Small Business Trends, MyCorporation, Small Biz Daily, StartupNation, and more. Email: <a href="mailto:meredith@fundera.com">meredith@fundera.com</a>.',
  },
  avatar: {
    sourceUrl:
      'https://secure.gravatar.com/avatar/1d46d37bcf4c56922f7f3b2b6b6d86b1?s=96&d=mm&r=g',
  },
  slug: 'meredith',
};

const MAINSITE_CATEGORIES = [
  'business-loans',
  'business-credit-cards',
  'business-accounting',
  'business-bank-accounts',
  'resources',
];

const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const UTM_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'msclkid',
];

const WIDTH_MAPPING = {
  SocialBanner: true,
  LoanProductModule: true,
  ValueProp: true,
  ProductComparisonModule: true,
  ProductCarousel: true,
  MultiProductReview: true,
};

const CONTENT_3_COL_PROPS = {
  header: {
    order: 1,
    span: 18,
    sm: 18,
    xs: 24,
  },
  left: {
    order: 2,
    lg: 6,
    // "sm: hasToC ? 16 : 0," -> will made it display on top between 992px -> 576px
    xs: 0, // 0 === display:none
  },
  main: {
    order: 3,
    lg: 12,
    xs: 24,
  },
  right: {
    order: 4,
    lg: 6,
    xs: 24,
  },
  rightInner: {
    offset: 0,
    span: 24,
    sm: { span: 24, offset: 0 },
    xs: { span: 24, offset: 0 },
  },
};

export {
  AVATARS,
  CONTENT_3_COL_PROPS,
  GENERAL_AUTHOR,
  MAINSITE_CATEGORIES,
  MONTH_NAMES,
  UTM_FIELDS,
  WIDTH_MAPPING,
};
